import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const MediasIcon: FC<IconProps> = memo(
  ({ size, width, height, ...props }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(64);
    return (
      <Svg
        viewBox="0 0 1024 1024"
        width={width ?? size}
        height={height ?? size}
        {...props}
      >
        <Path
          d="M447.6 375H96c-53 0-96-43-96-96v-71c0-53 43-96 96-96h335.4c44.8 0 83.7 31 93.6 74.7l16.2 70.9c13.7 60.1-31.9 117.4-93.6 117.4z"
          fill="#11A572"
        />
        <Path
          d="M958.6 947H65.4C29.3 947 0 917.7 0 881.6V261h958.6c36.1 0 65.4 29.3 65.4 65.4v555.3c0 36-29.3 65.3-65.4 65.3z"
          fill="#24C891"
        />
        <Path
          d="M354.1 425.8m-69.8 0a69.8 69.8 0 1 0 139.6 0 69.8 69.8 0 1 0-139.6 0Z"
          fill="#B8EADA"
        />
        <Path
          d="M598.2 833H232.9c-6 0-10.9-4.9-10.9-10.9v-79.3c0-3.4 1.6-6.6 4.3-8.7l177.4-133.3c4.7-3.5 11.3-2.7 15 1.9L600.1 829c1.3 1.6 0.2 4-1.9 4z"
          fill="#11A572"
        />
        <Path
          d="M704.3 507.7L426.5 817c-5.5 6.2-1.2 16 7.1 16h417c7.6 0 13.8-6.2 13.8-13.8v-190c0-4.1-1.8-8-5-10.7L723.3 506.2c-5.7-4.7-14.1-4-19 1.5z"
          fill="#B8EADA"
        />
      </Svg>
    );
  },
);
